import type { LcmSecurityRole } from 'abi-lcm-common-types';

export function formatRolesToString(roles?: LcmSecurityRole): string[] {
  if (!roles) return [];

  return Object.entries(roles)
    .filter(([, value]) => value)
    .map(([key]) => key);
}
